import { CplaceSingleNumberControlComponent, CplaceSingleNumberControlModule } from '../components';
import { CfControlPlugin } from './cf-control-plugin';

export class CplaceSingleNumberControlPlugin extends CfControlPlugin<CplaceSingleNumberControlComponent> {
  public readonly component = CplaceSingleNumberControlComponent;
  public readonly module = CplaceSingleNumberControlModule;
}
